const allowedAttributes = ['type', 'style', 'data-*'];

export default {
    allowedAttributes
}